<template>
    <div class="flex cursor-pointer transition-colors items-start my-2 relative" :class="[isActive?'isActiveLink':'']">

    <!-- Main button -->
            <div
            @click="btnClickHandler"
            class="w-full flex items-center justify-center col-start-1 "
            >
                <UIcon class="w-6 h-6 side-nav-icon" 
                :class="[btnColors, isActive ? 'is-active-icon !text-text-primary' : '', 'group-hover/sideNav:text-navigation-icon-hover']"
                :name="link.icon?link.icon:'i-heroicons-home'"
                /> 
            </div>
    </div>

</template>

<script setup lang="ts">
import type { Navigation } from '~/types/api/navigation'

interface Props {
    link: Navigation
    unfoldSubItem?: boolean
}

const {
    link,
    unfoldSubItem = false,
} = defineProps<Props>()

const isActive = ref(false)

const route = useRoute();

//// Active link logic
// const isActiveChecker = (currentRoute: string, linkToProp: string) => {
//     let modifiedPath = route.matched[0].path;
    
//     // Handle nested route parameters
//     if (route.params) {
//         Object.entries(route.params).forEach(([key, value]) => {
//             // Updated regex to match parameters with parentheses
//             const paramPattern = new RegExp(`:${key}\\(\\)`);
//             if (paramPattern.test(modifiedPath)) {
//                 modifiedPath = modifiedPath.replace(paramPattern, value as string);
//             }
//         });
//     }
//     //console.log("linkToProp", linkToProp);
//     //console.log("modifiedPath", modifiedPath);

//     isActive.value = linkToProp == modifiedPath;
// }

const isActiveChecker = () => {
    isActive.value = link.isActive
}

watch(
    () => route.path,
    () => {
        // isActiveChecker(route.path, props.link.to);
        isActiveChecker();
    
    },
    { immediate: true }
)



const expandSubitem = inject<Ref<boolean>>('navItemExpandSubitem', ref(false));

const btnColors = 'text-navigation-icon'

const btnStyling = computed(()=>{
    return {
        color:{black: {ghost: btnColors}},
        icon: {size: {xl: 'w-7 h-7'}}
        }
    }
)

const useIsNavClosed = useState('isNavClosed');

const subMenuHandler = computed(() => {
    return (unfoldSubItem || expandSubitem.value)
})

const btnClickHandler = async () => {
    if (link.subItems?.length) {
        if (useIsNavClosed.value) {
            useIsNavClosed.value = false
            expandSubitem.value = true
            return
        }

        expandSubitem.value = !expandSubitem.value
        return
    }

    if (link.to) {
        useIsNavClosed.value = true
        await navigateTo(link.to)
    }
}
</script>

<style lang="scss" scoped>

</style>